import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { fetchCompanyInfoSearch, fetchSearchResults } from './GlobalSearchService';

interface IGetSearchResultsPayload {
    parentOrgId: string;
    globalSearchText: string;
    userId?: string;
    cancelToken?: any; // optional
}

interface ICompanyInfoSearchPayload {
    cinNumber?: string;
    panNumber?: string;
    companyName?: string;
    cancelToken?: any;
}

export const getSearchResults = async (payload: IGetSearchResultsPayload) => {
    try {
        const { cancelToken, ...rest } = payload;
        const res = await fetchSearchResults(rest, cancelToken);

        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res.data?.data;
        } else {
            return false;
        }
    } catch (err) {
        console.error(err);
        return false;
    }
};

export const getCompanyInfoSearch = async (payload: ICompanyInfoSearchPayload) => {
    try {
        const { cancelToken, ...rest } = payload;
        const res = await fetchCompanyInfoSearch(rest, cancelToken);

        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res.data.data;
        }
        return false;
    } catch (err) {
        console.error(err);
        return false;
    }
};
